import React from "react";
import Alert from "react-bootstrap/Alert";
import "./notFound.scss";
import { ERROR, ErrorMessages } from "../../constants/constants";

const NotFound = ({ err, isWarning }) => {
  return (
    <div className="not-found-err-container">
      <Alert variant={isWarning ? "warning" : "error"} className="text-center">
        {typeof err === "object" &&
        err.problem === ERROR.CLIENT_ERROR &&
        err.status === 422
          ? ErrorMessages.SWITCH_ERROR
          : err === ERROR.NETWORK_ERROR
            ? ErrorMessages.NETWORK_ERROR
            : err === ERROR.CLIENT_ERROR
              ? ErrorMessages.CLIENT_ERROR
              : err === ERROR.SERVER_ERROR
                ? ErrorMessages.SERVER_ERROR
                : err === ERROR.ERROR_422
                  ? ErrorMessages.SWITCH_ERROR
                  : err}
      </Alert>
    </div>
  );
};

export default NotFound;
